import { Persistable, property, Remoteable, Supertype, supertypeClass } from '@haventech/amorphic';
import { BaseQuote } from '../BaseQuote';

@supertypeClass({ toClient: true, toServer: true })
export class QuoteExchange1035 extends Remoteable(Persistable(Supertype)) {
  @property({ comment: 'Cash value to be transferred from existing policy' })
  cashValueTransfer: number;

  @property({ comment: 'Amount that has been put into existing policy' })
  costBasis: number;

  @property({ comment: 'Type of existing policy' })
  policyType: string;

  @property({ comment: 'Destination the cash value transfer will be sent to' })
  applyTowards: string;

  @property({ comment: 'Expected arrival of the cash value transfer' })
  expectedArrival: number;

  @property({ comment: 'Is existing policy a MEC' })
  isMec: boolean;

  @property({
    getType: () => BaseQuote,
    comment: 'Quote to which this 1035 exchange is attached.',
  })
  quote: BaseQuote;

  constructor(
    cashValueTransfer: number,
    costBasis: number,
    policyType: string,
    applyTowards: string,
    expectedArrival: number,
    isMec: boolean,
    quote: BaseQuote
  ) {
    super();
    this.cashValueTransfer = cashValueTransfer;
    this.costBasis = costBasis;
    this.policyType = policyType;
    this.applyTowards = applyTowards;
    this.expectedArrival = expectedArrival;
    this.isMec = isMec;
    this.quote = quote;
  }
}
